import { DocumentStateIds } from '../../../model/DocumentState';
import { PsCompanyManagement } from '../../../model/PsCompanyManagement';

export class DocumentSearchRequest {

    _page; // number
    _term; // string
    _companyId; // number
    _schemaType; // number
    _documentStateIds; // number[]
    _companyManagement; // PsCompanyManagement
    _checkMonthly; // boolean

    constructor(
        schemaType,
        companyManagement,
        companyId = undefined,
        checkMonthly = false
    ) {
        this._page = 1;
        this._term = '';
        this._companyId = companyId;
        this._schemaType = schemaType;
        this._documentStateIds = undefined;
        this._companyManagement = companyManagement;
        this._checkMonthly = checkMonthly;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setCompany(companyId) {
        this._companyId = companyId;
    }

    setDocumentState(documentState) {
        this._documentStateIds = DocumentStateIds.includes(documentState) ? [documentState] : undefined;
    }

    setCheckMonthly(checkMonthly) {
        this._checkMonthly = checkMonthly;
    }

    asSubcontracted() {
        return this._companyManagement !== PsCompanyManagement.MY_OUTSOURCES;
    }

    hasCompanyId() {
        return !!this._companyId;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
                company_id: this._companyId,
                as_subcontracted: this.hasCompanyId() ? undefined : this.asSubcontracted(),
                document_state_ids: this._documentStateIds,
                document_schema_type_ids: [this._schemaType],
                check_monthly: this._checkMonthly,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/document/list/document-search/DocumentSearchRequest.js